// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"3e0e8a32","343":"d96a4af7","367":"73a2f919","451":"859f4286","495":"0ead25ba","819":"b1b6bbb6","969":"be0c6925","989":"bb34964b"}[chunkId] + ".chunk.css";
};